/*
 * File: FancyDateRangePicker.tsx
 * Project: professor-hastings
 * -----
 * Last Modified: 03 Feb 2022 1:18:18 am
 * -----
 * Copyright (c) 2022 Elegant Software Solutions All rights reserved.
 */

/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */

import { DatePicker } from 'antd';
import { RangePickerDateProps } from 'antd/lib/date-picker/generatePicker';
import { InlineStylesModel } from 'models/InlineStylesModel';
import { Moment } from 'moment';
import { FC, useRef, useState } from 'react';

const styles: InlineStylesModel = {
  form: {
    position: 'relative'
  },
  borderAnimation: {
    transition: 'all 0.3s ease'
  },
  input: {
    width: '100%',
    minWidth: 125
  },
  labelUnfocused: {
    position: 'absolute',
    color: 'rgba(0,0,0,0.50)',
    top: 5,
    left: 10,
    zIndex: 9999,
    transition: 'all 0.3s ease',
    visibility: 'hidden'
  },
  labelFocused: {
    backgroundColor: 'white',
    position: 'absolute',
    paddingLeft: 5,
    paddingRight: 5,
    zIndex: 9999,
    top: -15,
    left: 8,
    transition: 'all 0.3s ease'
  }
};

const { RangePicker } = DatePicker;

interface Props extends RangePickerDateProps<Moment> {
  rangeValues: Moment[];
  label: string;
  width?: string | number;
}

export const FancyDateRangePicker: FC<Props> = ({ rangeValues, label, width, ...rest }) => {
  const [isLabelTop, _setIsLabelTop] = useState(false);

  const inputRef = useRef(null);

  const inputWidth = width ? { ...styles.input, ...{ width } } : styles.input;

  const handleFocus = (): void => {
    _setIsLabelTop(true);
  };

  const handleBlur = (): void => {
    if (!rangeValues.length) {
      _setIsLabelTop(false);
    }
  };

  return (
    <div style={{ ...styles.form, ...styles.borderAnimation }}>
      <RangePicker {...rest} ref={inputRef} showTime={false} style={inputWidth} onFocus={handleFocus} onBlur={handleBlur} allowClear placeholder={['Request Start Date', 'Request End Date']} />
      <label style={isLabelTop ? styles.labelFocused : styles.labelUnfocused}>
        <span>{label}</span>
      </label>
    </div>
  );
};
